import { render, staticRenderFns } from "./menuCategory.vue?vue&type=template&id=6ae3ee18&scoped=true&"
import script from "./menuCategory.vue?vue&type=script&lang=js&"
export * from "./menuCategory.vue?vue&type=script&lang=js&"
import style0 from "./menuCategory.vue?vue&type=style&index=0&id=6ae3ee18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae3ee18",
  null
  
)

export default component.exports